import { createFileRoute } from '@tanstack/react-router';
import { useDashboardContext } from './dashboard-context';
import { ManagementDashboard } from './sections/Management';

export const Route = createFileRoute('/console/$orgId/dashboard/management')({
    component: RouteComponent,
});

function RouteComponent() {
    const { dashboards } = useDashboardContext();

    return (
        <ManagementDashboard
            loading={dashboards.loading.managementDashboard}
            data={dashboards.data.managementDashboard}
        />
    );
}
